import { Result } from '@app/features/premium/models/result';

import { TextHelpers } from '@global/infrastructure/helpers/text-helpers';

interface GwDate {
  day: number;
  month: number;
  year: number;
}

export class GwHelpers {
  static getGender(title: string, gender: string): string {
    if (gender) {
      return gender === 'Male' ? 'M' : 'F';
    }
    if (title) {
      return title.toLowerCase() === 'mr' ? 'M' : 'F';
    }
    return null;
  }

  static convertToBoolean(value: any): boolean {
    return value === undefined
      ? false
      : typeof value === 'boolean'
      ? value
      : (value as string).toLowerCase() === 'yes';
  }

  static deletePromCodes(result: Result): Result {
    const premDataResultClone: Result = JSON.parse(JSON.stringify(result));

    const {
      lobData: {
        mOTLine_Ext: { offerings: offerings },
      },
    } = premDataResultClone;
    if (offerings && offerings.length) {
      offerings.forEach((offering) => {
        if (offering.coverages && offering.coverages.vehicleCoverages) {
          offering.coverages.vehicleCoverages.forEach((vehicleCoverage) => {
            delete vehicleCoverage.automaticAppliedPromos_dlg;
          });
        }
      });
    }

    return premDataResultClone;
  }

  static convertToGwDateObject(dmy: string[] | number[]) {
    if (dmy?.length) {
      return {
        day: dmy[0] ? +dmy[0] : 1,
        month: +dmy[1] - 1,
        year: +dmy[2],
      };
    }
    return null;
  }

  static convertGwDateToDate(dt: GwDate): Date {
    if (!dt) { return null; }
    const { day, month, year } = dt;
    return new Date(year, month, day);
  }

  static convertGwDateToDlgDate(dt: GwDate): number[] {
    if (!dt) { return []; }
    const { day, month, year } = dt;
    return [day, month + 1, year];
  }

  static convertTitleForPayload(title: string): string {
    return title.toLowerCase() !== 'miss' ? title.toLowerCase() : 'miss_dlg';
  }

  static convertTitleForDisplay(title: string): string {
    return title.toLowerCase() !== 'miss_dlg'
      ? TextHelpers.convertToTitleCase(title)
      : 'Miss';
  }

  static getGenderForDisplay(gender: string): string {
    if (gender.toLowerCase() === 'm') {
      return 'Male';
    }
    if (gender.toLowerCase() === 'f') {
      return 'Female';
    }
    return '';
  }
}
